import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from './Slider';

class ProgressBar extends Component {
  constructor() {
    super();
    this.shiftAudioProgress = this.shiftAudioProgress.bind(this);
  }

  shiftAudioProgress(audioProgress) {
    this.props.shiftAudioProgress(audioProgress);
  }

  render() {
    return (
      <div className="browser-audio-progress-bar">
        <Slider pixelLength={230} percentComplete={this.props.audioProgress} shiftPercentComplete={this.shiftAudioProgress}/>
        <div className="browser-audio-progress-time">{this.props.audioTime}</div>
      </div>
    );
  }
}

ProgressBar.propTypes = {
  audioProgress: PropTypes.number.isRequired,
  audioTime: PropTypes.string.isRequired,
  shiftAudioProgress: PropTypes.func.isRequired
};

export default ProgressBar;
